import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6666600e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "top-bar-buffer"
}
const _hoisted_3 = {
  key: 1,
  class: "top-bar-container"
}
const _hoisted_4 = { class: "top-bar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right-section" }, null, -1))
const _hoisted_6 = { id: "content-capped-width" }
const _hoisted_7 = {
  key: "error",
  class: "empty-data"
}
const _hoisted_8 = { key: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeasonalBanner = _resolveComponent("SeasonalBanner")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_HomeLoadingState = _resolveComponent("HomeLoadingState")!
  const _component_Profile = _resolveComponent("Profile")!
  const _component_ErrorPage = _resolveComponent("ErrorPage")!
  const _component_EmptyPageHome = _resolveComponent("EmptyPageHome")!
  const _component_NotificationsPanel = _resolveComponent("NotificationsPanel")!
  const _component_HomeContent = _resolveComponent("HomeContent")!
  const _component_PullToRefreshWrapper = _resolveComponent("PullToRefreshWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SeasonalBanner, { onShowSeasonalBanner: _ctx.onToggleSeasonalBanner }, null, 8, ["onShowSeasonalBanner"]),
    (_ctx.fromDrillDown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.fromDrillDown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Typography, {
              component: "span",
              class: "back navigation-text",
              onClick: _ctx.backAction
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, {
                  class: "chevron-left",
                  size: "lg",
                  icon: _ctx.faChevronLeft
                }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.topBarBackLabel), 1)
              ], undefined, true),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Typography, {
              key: "NICE",
              component: "span",
              class: "title-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.topBarTitle), 1)
              ], undefined, true),
              _: 1
            }),
            _hoisted_5
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PullToRefreshWrapper, {
      ref: "refreshContainerHome",
      disable: _ctx.showReportCard || _ctx.notificationPanelOpen,
      "ptr-refreshing": _ctx.loading,
      "refresh-container-classes": _ctx.refreshContainerClasses,
      onRefreshAction: _ctx.pullToRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_TransitionGroup, { appear: "" }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_HomeLoadingState, {
                    key: "loading",
                    "hide-profile": _ctx.loading && _ctx.hideProfile
                  }, null, 8, ["hide-profile"]))
                : (_ctx.allDataIsEmpty || _ctx.allRequestsHaveErrors)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_Profile, {
                        key: "profile",
                        "selected-user-name": _ctx.drillDownUser.name,
                        "selected-user-type": _ctx.selectedUserType,
                        "show-notifications": false
                      }, null, 8, ["selected-user-name", "selected-user-type"]),
                      (_ctx.allRequestsHaveErrors)
                        ? (_openBlock(), _createBlock(_component_ErrorPage, { key: 0 }))
                        : (_openBlock(), _createBlock(_component_EmptyPageHome, {
                            key: 1,
                            message: _ctx.emptyTopicMessage
                          }, null, 8, ["message"]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_Profile, {
                        key: "profile",
                        "selected-user-name": _ctx.drillDownUser.name,
                        "selected-user-type": _ctx.selectedUserType,
                        "from-drill-down": _ctx.fromDrillDown
                      }, null, 8, ["selected-user-name", "selected-user-type", "from-drill-down"]),
                      (_ctx.notificationPanelOpen && _ctx.hasNetworkConnection)
                        ? (_openBlock(), _createBlock(_component_NotificationsPanel, { key: "notification" }))
                        : (!_ctx.notificationPanelOpen)
                          ? (_openBlock(), _createBlock(_component_HomeContent, {
                              key: 1,
                              "filter-key": _ctx.filterKey,
                              "refresh-topic": _ctx.refreshTopic,
                              "show-goal-tracking": _ctx.showGoalTracking,
                              onSetShowReportCard: _ctx.setShowReportCard,
                              onToggleShowGoalTracking: _ctx.toggleShowGoalTracking
                            }, null, 8, ["filter-key", "refresh-topic", "show-goal-tracking", "onSetShowReportCard", "onToggleShowGoalTracking"]))
                          : _createCommentVNode("", true)
                    ]))
            ], undefined, true),
            _: 1
          })
        ])
      ], undefined, true),
      _: 1
    }, 8, ["disable", "ptr-refreshing", "refresh-container-classes", "onRefreshAction"])
  ]))
}